import investmentProgramsActions from "./investmentProgramsActions";

export default investmentProgramsActions;
